import { cn } from "@/lib/utils";

/**
 * Amy's mascot face in a circle — the same `/amy.svg` asset used by
 * `ui/amy-badge.tsx`, onboarding, and the easter egg. Size via `className`.
 */
export function AmyAvatar({ className }: { className?: string }) {
  return (
    <img
      src="/amy.svg"
      alt="Amy"
      decoding="async"
      draggable={false}
      className={cn(
        "size-7 shrink-0 rounded-pill border bg-background object-cover",
        className
      )}
    />
  );
}
